var map = {
	"./hover/moon.svg": "Xq1a",
	"./hover/sun.svg": "KetN",
	"./moon.svg": "RIr8",
	"./sun.svg": "fDvi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RWoX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme ^\.\/.*\.svg$
// module id = RWoX
// module chunks = 14